import templateUrl from "servicestack/auto-query/auto-query-refinements-bar.htm";
import controller from "servicestack/basic.controller";

export default {
  bindings: {
    title: "@",
    query: "<",
    enableClearAll: "<",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
